export default __webpack_public_path__ + "static/media/Screen Shot 2021-06-29 at 9.30.03 PM.c31c5449.png";